import { BooleanCons, HttpStatus, NumberCons, StringConst } from '../../constants/const';
import { BaseResponseHttp } from './commons.model';
import { CallPlace } from './myActivity.model';
import { TotalDescriptionShopping } from '../local/general.model';
import { PrescriptionName } from '../local/prescription-name.model';
import { PrescriptionNamesView } from '../local/prescriptionNamesView';
import { PaymentInformation } from '../local/payment.model';
import { CreditNotes } from './favorBalance.model';

export interface IPreviewReceiptRes extends BaseResponseHttp {
  response: string;
}

export interface IConfirmOrderResponse extends BaseResponseHttp {
  response: PaymentInformation;
}
export interface IConfirmationRes extends BaseResponseHttp {
  response: ResponseConfirm;
}
export interface AuthorizedOrderResponse extends BaseResponseHttp {
  response: AuthorizeOrder;
}
export class AuthorizeOrder {
  paymentBreakdown: PaymentBreakdown;
  paymentMethod: PaymentInformation;
  constructor() {
    this.paymentBreakdown = new PaymentBreakdown();
    this.paymentMethod = new PaymentInformation();
  }
}
export interface ChangePaymentMethodResponse extends BaseResponseHttp {
  response: ChangePaymentMethod;
}
export class ChangePaymentMethod extends AuthorizeOrder {
  creationDate: Date;
  constructor() {
    super();
    this.creationDate = new Date();
  }
}

export interface PayPalCreateOrderResponse extends BaseResponseHttp {
  response: PaypalCreateOrder;
}

export class PaypalCreateOrder {
  transactionId: string;
  cardCode: string;
  orderResponse: PaypalOrder;
  constructor() {
    this.transactionId = StringConst.empty;
    this.cardCode = StringConst.empty;
    this.orderResponse = new PaypalOrder();
  }
}
export class PaypalOrder {
  id: string;
  status: string;
  links: PaypalLink[];
  constructor() {
    this.id = StringConst.empty;
    this.status = StringConst.empty;
    this.links = [];
  }
}
export class PaypalLink {
  href: string;
  rel: string;
  method: string;
  constructor() {
    this.href = StringConst.empty;
    this.rel = StringConst.empty;
    this.method = StringConst.empty;
  }
}
export class SavePaypalOrderRequest {
  cardCode: string;
  cartType: number;
  transactionId: string;
  shippingCost: number;
  doctorSpeciality: string;
  promotionalCode: string;
  priceListId: number;
  clientType: string;
  shippingCostDiscount: number;
  constructor() {
    this.cardCode = StringConst.empty;
    this.cartType = NumberCons.zero;
    this.transactionId = StringConst.empty;
    this.shippingCost = NumberCons.zero;
    this.doctorSpeciality = StringConst.empty;
    this.promotionalCode = StringConst.empty;
    this.priceListId = NumberCons.zero;
    this.clientType = StringConst.empty;
    this.shippingCostDiscount = NumberCons.zero;
  }
}
export class ResponseConfirm {
  paymentMethod: PaymentInformation;
  paymentBreakdown?: PaymentBreakdown;
  cardResponse: CardResponseChange;
  creationDate: Date;
  amount: number;
  status: string;
  description: string;
  transactionType: string;
  operationType: string;
  method: string;
  bankAccount?: any;
  authorization?: any;
  orderId: string;
  customerId: string;
  conciliated: string;
  dueDate: Date;
  id: string;
  constructor() {
    this.paymentMethod = new PaymentInformation();
    this.paymentBreakdown = new PaymentBreakdown();
    this.creationDate = new Date();
    this.amount = NumberCons.zero;
    this.status = StringConst.empty;
    this.description = StringConst.empty;
    this.transactionType = StringConst.empty;
    this.operationType = StringConst.empty;
    this.method = StringConst.empty;
    this.orderId = StringConst.empty;
    this.customerId = StringConst.empty;
    this.conciliated = StringConst.empty;
    this.dueDate = new Date();
    this.id = StringConst.empty;
    this.cardResponse = new CardResponseChange();
  }
}

export class CardResponseChange {
  cardId: string;
  cardNumber: string;
  brand: string;
  bankName: string;
  aliasCard: string;
  constructor() {
    this.cardId = StringConst.empty;
    this.cardNumber = StringConst.empty;
    this.brand = StringConst.empty;
    this.bankName = StringConst.empty;
    this.aliasCard = StringConst.empty;
  }
}
export interface SuccessPayMethod {
  totalDescription: TotalDescriptionShopping;
  data: PaymentInformation;
  callPlace?: CallPlace;
  rol?: string;
  nameDoctor?: string;
  showAmountSaved?: boolean;
  shippingCostAccept?: boolean;
  lowerDialog?: boolean;
  idsurvey?: string;
}

export class SuccessPayDialogInfo {
  totalDescription: TotalDescriptionShopping;
  shippingCostAcepted: boolean;
  data: PaymentInformation;
  constructor() {
    this.totalDescription = new TotalDescriptionShopping();
    this.shippingCostAcepted = BooleanCons.false;
    this.data = new PaymentInformation();
  }
}

export class PaymentBreakdown {
  productTotal: number;
  piecesTotal: number;
  tax: number;
  costShipping: number;
  totalDiscount: number;
  total: number;
  subTotal: number;
  isShippingCostAccepted: boolean;
  hasDiscountSpecial: boolean;
  percentDiscountSpecial: number;
  creditNoteAmount: number;
  discountSpecialAmount: number;
  promotionalCodeAmount: number;
  costShippingDiscount: number;
  constructor() {
    this.productTotal = NumberCons.zero;
    this.piecesTotal = NumberCons.zero;
    this.tax = NumberCons.zero;
    this.costShipping = NumberCons.zero;
    this.totalDiscount = NumberCons.zero;
    this.total = NumberCons.zero;
    this.subTotal = NumberCons.zero;
    this.isShippingCostAccepted = BooleanCons.false;
    this.hasDiscountSpecial = BooleanCons.false;
    this.percentDiscountSpecial = NumberCons.zero;
    this.creditNoteAmount = NumberCons.zero;
    this.discountSpecialAmount = NumberCons.zero;
    this.promotionalCodeAmount = NumberCons.zero;
    this.costShippingDiscount = NumberCons.zero;
  }
}
export class PaymentMethod {
  type: string;
  bankName: string;
  clabe: string;
  name: string;
  reference?: any;
  agreement: string;
  barcodeUrl?: any;

  constructor() {
    this.type = StringConst.empty;
    this.bankName = StringConst.empty;
    this.clabe = StringConst.empty;
    this.name = StringConst.empty;
    this.agreement = StringConst.empty;
  }
}
export class CodePayDescription {
  reference: string;
  created: Date;
  expiration: Date;
  dueDate: string;
  barcodeUrl: string;
  totalDescription: TotalDescriptionShopping;
  shippingCostAccept: boolean;
  callPlace: CallPlace;
  constructor() {
    this.expiration = new Date();
    this.reference = StringConst.empty;
    this.created = new Date();
    this.barcodeUrl = StringConst.empty;
    this.totalDescription = new TotalDescriptionShopping();
    this.shippingCostAccept = BooleanCons.false;
    this.callPlace = CallPlace.default;
    this.dueDate = StringConst.empty;
  }
}
export class ConfirmOrderReq {
  cardCode: string;
  totalProducts: number;
  totalCost: number;
  advisorName: string;
  paymentMethod: string;
  cardId: string;
  cartType: number;
  needsInvoice: boolean;
  sesionId: string;
  deliveryAddress: string;
  invoiceAddress: string;
  deliveryAddressId: string;
  invoiceAddressId: string;
  customerId: string;
  totalPieces: number;
  needsRecipe: boolean;
  email: string;
  iva: number;
  doctorName: string;
  paymentMethodService?: string;
  createName: string;
  cardNumber: string;
  shippingCostAccepted: number;
  discountAmount: number;
  namesPrescriptions: Array<PrescriptionName>;
  cfdiValue: string;
  discountSpecial: number;
  userRfc: string;
  profecionalLicense: string;
  typeOrder: string;
  orderCategory: PaypalOrderCategory;
  creditNotes: CreditNotes[];
  discountSpecialAmount: number;
  subtotal: number;
  promotionalCodeAmount: number;
  promotionalCode: string;
  doctorSpeciality: string;
  deliveryComments: string;
  deliverySuggestedTime: string;
  isDoctorDirection: boolean;
  priceListId: number;
  clientType: string;
  shippingCostDiscount: number;
  idsurvey: string;
  invoicetype: string;
  monthlyInstallments?: number | null;
  expectedMonthlyAmount?: number | null;
  constructor() {
    this.cardCode = StringConst.empty;
    this.totalProducts = NumberCons.zero;
    this.totalCost = NumberCons.zero;
    this.advisorName = StringConst.empty;
    this.paymentMethod = StringConst.empty;
    this.cardId = StringConst.empty;
    this.cartType = NumberCons.zero;
    this.needsInvoice = BooleanCons.false;
    this.sesionId = StringConst.empty;
    this.deliveryAddress = StringConst.empty;
    this.invoiceAddress = StringConst.empty;
    this.deliveryAddressId = StringConst.empty;
    this.invoiceAddressId = StringConst.empty;
    this.customerId = StringConst.empty;
    this.totalPieces = NumberCons.zero;
    this.needsRecipe = BooleanCons.false;
    this.email = StringConst.empty;
    this.iva = NumberCons.zero;
    this.doctorName = StringConst.empty;
    this.paymentMethodService = StringConst.empty;
    this.createName = StringConst.empty;
    this.cardNumber = StringConst.empty;
    this.shippingCostAccepted = NumberCons.zero;
    this.discountAmount = NumberCons.zero;
    this.namesPrescriptions = [];
    this.cfdiValue = StringConst.empty;
    this.discountSpecial = NumberCons.zero;
    this.userRfc = StringConst.empty;
    this.profecionalLicense = StringConst.empty;
    this.typeOrder = StringConst.empty;
    this.orderCategory = PaypalOrderCategory.default;
    this.creditNotes = [];
    this.discountSpecialAmount = NumberCons.zero;
    this.subtotal = NumberCons.zero;
    this.promotionalCodeAmount = NumberCons.zero;
    this.promotionalCode = StringConst.empty;
    this.doctorSpeciality = StringConst.empty;
    this.deliveryComments = StringConst.empty;
    this.deliverySuggestedTime = StringConst.empty;
    this.isDoctorDirection = BooleanCons.false;
    this.priceListId = NumberCons.zero;
    this.clientType = StringConst.empty;
    this.shippingCostDiscount = NumberCons.zero;
    this.idsurvey = StringConst.empty;
    this.invoicetype = StringConst.empty;
  }
}

export enum PaypalOrderCategory {
  order = 'order',
  invoice = 'invoice',
  invoiceChange = 'invoiceChangePayment',
  default = ''
}
export class INipValidationReq {
  cardCode: string;
  Hash: string;
  Nip: string;

  constructor() {
    this.cardCode = StringConst.empty;
    this.Hash = StringConst.empty;
    this.Nip = StringConst.empty;
  }
}

export class ReceiptPreview {
  doctorId: string;
  cartType: number;
  needsProducts: boolean;
  isPreview: boolean;
  patients: PrescriptionNamesView[];
  transactionID?: string | null;
  transactionId?: string | null;
  clientType: string | null;
  aliasAddress?: string | null;
  constructor() {
    this.doctorId = StringConst.empty;
    this.cartType = NumberCons.zero;
    this.isPreview = false;
    this.needsProducts = false;
    this.patients = [];
    this.transactionID = null;
    this.transactionId = null;
    this.clientType = null;
    this.aliasAddress = null;
  }
}

export class OptionsDoctorInfo {
  callPlace: CallPlace;
  isOnlyTesting?: boolean;
  constructor() {
    this.callPlace = CallPlace.default;
  }
}

export class PrintQuote {
  doctorId: string;
  cartType: number;
  specialityDoctor: string;
  doctorName: string;
  totalProducts: number;
  totalPieces: number;
  subTotal: number;
  tax: number;
  amountTotal: number;
  discount: number;
  shippingCost: number;
  discountSpecial: number;
  promotionalCode: string;
  promotionalCodeAmount: number;
  priceListId: number;
  clientType: string;
  constructor() {
    this.doctorId = StringConst.empty;
    this.cartType = NumberCons.one;
    this.specialityDoctor = StringConst.empty;
    this.doctorName = StringConst.empty;
    this.totalProducts = NumberCons.zero;
    this.totalPieces = NumberCons.zero;
    this.subTotal = NumberCons.zero;
    this.tax = NumberCons.zero;
    this.amountTotal = NumberCons.zero;
    this.discount = NumberCons.zero;
    this.shippingCost = NumberCons.zero;
    this.discountSpecial = NumberCons.zero;
    this.promotionalCodeAmount = NumberCons.zero;
    this.promotionalCode = StringConst.empty;
    this.priceListId = NumberCons.zero;
    this.clientType = StringConst.empty;
  }
}

export class ResponsePrintQuote {
  code: number;
  userError?: string | null;
  exceptionMessage?: string | null;
  success: boolean;
  response: string;
  comments?: string | null;

  constructor() {
    this.code = HttpStatus.ok;
    this.userError = null;
    this.exceptionMessage = null;
    this.success = false;
    this.response = StringConst.empty;
    this.comments = null;
  }
}
